import ButtonBase from '@mui/material/ButtonBase';
import { alpha, styled } from '@mui/material/styles';
import type { ScrollHiddenItemsHintPlacement } from './ScrollHiddenItemsHint.props';

interface ScrollHiddenItemsHintStyleProps {
  placement: ScrollHiddenItemsHintPlacement;
}

const shouldForwardScrollHintProp = (prop: PropertyKey) => prop !== 'placement';

export const ScrollHiddenItemsHintRoot = styled(ButtonBase, {
  shouldForwardProp: shouldForwardScrollHintProp,
})<ScrollHiddenItemsHintStyleProps>(({ placement, theme }) => ({
  [placement]: 'var(--scroll-hidden-items-hint-offset, 4px)',
  alignItems: 'center',
  backgroundColor: alpha(theme.palette.brand[700], 0.98),
  border: `var(--scroll-hidden-items-hint-border-width, 1px) solid ${alpha(theme.palette.neutral.white, 0.18)}`,
  borderRadius: 'var(--scroll-hidden-items-hint-radius, 4px)',
  boxShadow: `0 4px 12px ${alpha(theme.palette.brand[900], 0.22)}`,
  color: theme.palette.neutral.white,
  display: 'inline-flex',
  fontSize: 'var(--scroll-hidden-items-hint-font-size, 12px)',
  fontWeight: theme.typography.fontWeightRegular,
  gap: 'var(--scroll-hidden-items-hint-gap, 4px)',
  justifyContent: 'center',
  left: '50%',
  lineHeight: 'var(--scroll-hidden-items-hint-line-height, 16px)',
  padding: 'var(--scroll-hidden-items-hint-padding, 2px 6px)',
  position: 'absolute',
  transform: 'translateX(-50%)',
  transition: theme.transitions.create(['background-color', 'box-shadow', 'opacity', 'transform'], {
    duration: theme.transitions.duration.shortest,
  }),
  whiteSpace: 'nowrap',
  zIndex: 10,
  '&:hover, &:focus-visible': {
    backgroundColor: theme.palette.brand[800],
    boxShadow: `0 6px 16px ${alpha(theme.palette.brand[900], 0.28)}`,
    outline: 0,
  },
  '& svg': {
    fontSize: 'var(--scroll-hidden-items-hint-icon-size, var(--scroll-hidden-items-hint-font-size, 12px))',
  },
}));
